import { FAQ } from 'sections/DigitalTools/LogisticsExplorer/types';

export const faq: FAQ[] = [
  {
    id: "1",
    question: "How to calculate sea freight cost?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Use our logistics freight calculator to carefully choose your cargo’s collection point, preferred transport mode, and shipment specifications. The system then swiftly calculates real-time shipping cost estimates, giving you complete clarity and cost control in your logistics planning.
        </p>
      `
    ),
  },
  {
    id: "2",
    question: "How accurate is the sea freight distance calculation in Logistics Explorer?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Very accurate. The calculator delivers precise pricing by combining certified port-to-port distances with carrier-specific transit times. This smart system ensures shipping cost estimates are closely aligned with real-world conditions.
        </p>
      `
    ),
  },
  {
    id: "3",
    question: "Can I calculate freight rates with the Sea Freight Calculator for different shipping routes?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Yes, the tool allows you to compare a variety of route choices, carriers, and contract terms across different transport types. With built-in support for cross-modal calculations, covering sea, air, rail, and road, you can confidently choose the most convenient shipping solution.
        </p>
      `
    ),
  },
  {
    id: "4",
    question: "What is included in ocean freight charges?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Freight charges typically include the base rate, fuel surcharges, terminal handling charges, and other carrier-related fees. Logistics Explorer provides a breakdown wherever possible.
        </p>
      `
    ),
  },
];